// extracted by mini-css-extract-plugin
export var amenities = "styles-module--amenities--d9412";
export var details = "styles-module--details--0ff33";
export var detailsItem = "styles-module--detailsItem--63c55";
export var discount = "styles-module--discount--e66b3";
export var img = "styles-module--img--b24bf";
export var info = "styles-module--info--71d9c";
export var light = "styles-module--light--f16ba";
export var lodgingSliderCell = "styles-module--lodgingSliderCell--dac1b";
export var lodgingSliderCellWrapper = "styles-module--lodgingSliderCellWrapper--6b9dc";
export var priceInfo = "styles-module--priceInfo--5454c";
export var priceWrapper = "styles-module--priceWrapper--d4c21";
export var selectedCell = "styles-module--selectedCell--b914e";
export var title = "styles-module--title--63c1f";